import { Component, Input } from '@angular/core';
import { Permission } from 'app/shared/models/permission';
import { PermissionsNavigatorHelper } from 'app/permissions/permissions-navigator-helper';

@Component({
  selector: 'app-permission-set-details-general',
  templateUrl: './permission-details-general.component.html',
})
export class PermissionDetailsGeneralComponent {
  @Input()
  item: Permission;

  constructor(protected navigatorHelper: PermissionsNavigatorHelper) {}
}
